








































import { Component, Mixins } from 'vue-property-decorator';
import Layout from '@/layouts/Layout';
import DishForm from '@/components/menu-engineering/DishForm.vue';
import DishList from '@/components/menu-engineering/DishList.vue';
import MenuEngineeringLogic from '@/logic/menu-engineering/MenuEngineeringLogic';
import { Dish, DishCourseEnum, Restaurant } from '@/api/model';
import RestaurantNameForm from '@/components/profile/RestaurantNameForm.vue';
import MessageToastMixin from '@/mixins/MessageToastMixin';

@Component({
  components: { RestaurantNameForm, Layout, DishForm, DishList },
})
export default class MenuEngineeringAddDish extends Mixins(MessageToastMixin) {
  // Dish model for the form
  dish: Dish = {};

  saving = false;

  loadingRestaurants = false;

  get state() {
    return this.$store.state.menuEngineering;
  }

  // List of user dishes
  get dishes(): Dish[] {
    return this.state.dishes;
  }

  // User restaurants
  get restaurants(): Restaurant[] {
    return this.$store.state.restaurant.restaurants;
  }

  get filteredDishes(): Dish[] {
    return MenuEngineeringLogic.filterDishes(
      this.dishes,
      this.dish.restaurantId,
      this.dish.course,
    );
  }

  get minimumAmountOfDishesReached(): boolean {
    return MenuEngineeringLogic.minimumAmountOfDishesReached(
      this.filteredDishes,
    );
  }

  get restaurant(): Restaurant | undefined {
    if (!this.restaurants || this.restaurants.length === 0) {
      return undefined;
    }

    return (
      this.restaurants.find(
        (restaurant) => restaurant.id === this.dish.restaurantId,
      ) || this.restaurants[0]
    );
  }

  get course(): string {
    return this.dish.course || DishCourseEnum.Breakfast;
  }

  created() {
    this.resetDish();
    this.getRestaurants();
    this.getDishes();
  }

  resetDish() {
    this.dish = {
      restaurantId: this.$store.state.restaurant.activeRestaurantId,
      course: this.state.activeCourse,
      name: '',
      popularity: 0,
      costPrice: 0,
      chefTime: 0,
      staffTime: 0,
      price: 0,
    };
  }

  async getRestaurants() {
    this.loadingRestaurants = true;
    await this.$store.dispatch('restaurant/getRestaurants');
    this.loadingRestaurants = false;
  }

  getDishes() {
    this.$store.dispatch('menuEngineering/getDishes');
  }

  async save() {
    this.saving = true;
    try {
      await this.$store.dispatch('menuEngineering/saveDish', this.dish);
      this.saving = false;
      this.showSuccess(this.$t('menuEngineering.label.addDishEquation'));
      this.resetDish();
    } catch (e) {
      this.saving = false;
      this.showError(this.$t('general.messages.error'));
    }
  }

  async deleteDish(deleteDish: Dish) {
    try {
      await this.$store.dispatch('menuEngineering/deleteDish', deleteDish);
    } catch (e) {
      this.showError(this.$t('menuEngineering.label.dishNotDeleted'));
    }
  }
}
